<template>
      <!-- Main content -->
  <div class="main-content" id="panel">
    <!-- Topnav -->
    <!-- <Header /> -->
    <!-- Header -->
    <!-- Header -->
    <div class="header bg-primary pb-6">
      <div class="container-fluid">
        <div class="header-body">
          <h2 class="pt-4">Outstanding Bids</h2>
          <div class="row align-items-center pb-4">
            <div class="col-md-12 text-right bid">
                <div class="input-group d-inline-flex justify-content-end">
                  
                  <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0 w-17">
                    <i @click="searchBid()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                    <input v-on:keyup.enter="searchBid" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search Cusip" aria-label="Search">
                    <i  v-if="searchValue" @click="clearSearch()"  class="fas fa-times-circle cursor-pointer"></i>
                  </form>
                  <div class="upYld mb-2">
                    <select class="form-select" id="inputGroupSelect01" v-model="allBidValueOperator" >
                      <option value="+">+</option>
                      <option value="-">-</option>
                    </select> 
                    <input type="text" class="form-control" @keypress="isNumber($event)" v-model="allBidValue">
                    <button :disabled="allBidValue == ''|| bidValues.bidsCount == 0" @click="openPriceUpdateConfirm()"  class="btn btn-success mr-2" type="button">Update {{bidsSelectedUpdate.length == 0 ? 'All' : 'Selected'}} Bid Price</button>
                  </div>
                  

                  <!-- <div class="upYld mb-2">
                    <select class="form-select" id="inputGroupSelect01" v-model="allYieldValueOperator" >
                      <option value="+">+</option>
                      <option value="-">-</option>
                    </select> 
                    <input type="text" class="form-control" @keypress="isNumber($event)" v-model="allYieldValue">
                    <div class="position-absolute">%</div>
                  </div> -->
                  <!-- <button :disabled="allYieldValue == ''" @click="openYieldUpdateConfirm()"  class="btn btn-success mr-2 mb-2" type="button">Update {{bidsSelectedUpdate.length == 0 ? 'All' : 'Selected'}} Bid Yields</button> -->
                  
                  <div class="upYld mb-2">
                    <select v-model="selectedBidValidity" class="form-control number rounded-left" id="exampleFormControlSelect1">
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                    </select> 
                  <button :disabled="bidValues.bidsCount == 0" type="button" @click="updateAllBidValidity()" class="btn btn-success mr-2 ">Update {{bidsSelectedUpdate.length == 0 ? 'All' : 'Selected'}} Bid Validity</button>
                </div>
                
                  <button :disabled="bidValues.bidsCount == 0" type="button" class="btn btn-danger mb-2" data-toggle="modal" data-target="#cancelAllBidModal"><i class="fas fa-times-circle"></i> Cancel All Bids</button>
                </div>                
            </div>
            <div class="col-lg-12 col-12 bid mt-4">
               <form class="form-inline dt-filter justify-content-end">
                  <!-- <label for="filter" class="col-form-label">Filter</label> -->
                  <div class="bg-white rounded py-2 px-3 mr-3">Total Bids : <b>{{bidValues.bidsCount}}</b></div>
                  <div class="bg-white rounded py-2 px-3 mr-3">Par : <b>{{bidValues.bidsQuantity}}</b></div>
                  <div class="form-group">
                    <label for="filter" class="col-form-label">From</label>
                    <datepicker v-model="fromDateExport" placeholder="mm/dd/yyyy"  name="fromDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <div class="form-group">
                    <label for="filter" class="col-form-label">To</label>
                    <datepicker v-model="toDateExport" placeholder="mm/dd/yyyy"  name="toDate" format="MM/dd/yyyy" :clear-button="true" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker>
                  </div>
                  <button :disabled="!fromDateExport || !toDateExport" type="button" @click="exportToExcel()" class="btn btn-warning rounded"><i class="fas fa-download"></i> EXPORT</button>
                </form>
            </div>
          </div>
          <!-- Card stats -->
        </div>
        <div v-if="isAdmin" class="filter-show">
            <div class="card w-100 p-2 mb-2  d-inline-block">
              <div class="d-flex justify-content-between">
                <h5 class="ml-3">Filters</h5>
                <span class="btn btn-link" @click="showFilters = !showFilters">
                  <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
                </span>
              </div>
              <div class="row" v-if="showFilters">
                <div class="col-lg-12">
                  <form class="row">
                  <div class="col-md-3">
                    <label for="filter" class="col-form-label">Trader</label>
                    <multiselect 
                      v-model="filterTrader" 
                      placeholder="Select trader" 
                      label="firstName" 
                      track-by="id"
                      :options="traderList"  
                      :limit="3"  ></multiselect>
                  </div>
                   <div class="col-md-2" style="top:12px">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded ml-0">Clear</button>
                    <button @click="getBidList()" type="button" class="btn btn-primary rounded ml-0">Filter</button>
                   </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    
    <div class="container-fluid mt--6">
      <div class="row xsOnly">
        <div class="col-xl-12">
          
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>
              <table class="table align-items-center table-flush table-hover bidtbl">
                <thead class="thead-light psticky">
                  <tr>
                    <th 
                      scope="col" 
                      class="text-center"
                      ><input v-model="isSelectAll" @change="selectAll()" type="checkbox" class="form-check-input" /></th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                      @click="sort('cusip')">CUSIP/COUPON</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'maturityDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'maturityDate'  ? 'sort-desc' : '']"  
                      @click="sort('maturityDate')">MATURITY DATE/<br>CALL DATE</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'state'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'state'  ? 'sort-desc' : '']"  
                      @click="sort('state')">STATE/<br>INSURER</th>
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'amount'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'amount'  ? 'sort-desc' : '']"  
                      @click="sort('amount')">BID PRICE</th>
                      <!-- <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'tmcPrice'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'tmcPrice'  ? 'sort-desc' : '']"  
                      @click="sort('tmcPrice')">TMC PRICE</th> -->
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                      @click="sort('quantity')">PAR <br> VALUE</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                      @click="sort('minQuantity')">MINIMUM <br> QUANTITY</th>
                     <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidKeepCancel'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidKeepCancel'  ? 'sort-desc' : '']"  
                      @click="sort('bidKeepCancel')">MINIMUM QUANTITY <br> BID OPTION</th>  
                    <th 
                      scope="col" 
                      class="sort"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'bidValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'bidValidity'  ? 'sort-desc' : '']"  
                      @click="sort('bidValidity')"># OF DAYS</th>
                    <!-- <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'pointToDate'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'pointToDate'  ? 'sort-desc' : '']"  
                      @click="sort('pointToDate')">POINT TO</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                      @click="sort('curveYield')">CURVE<br>YIELD</th>
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                      @click="sort('yieldSpread')">YIELD <br> SPREAD </th>
                      <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                      @click="sort('minBps')">BPS RANGE <br> MIN/MAX </th>
                   
                    <th 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'factorRatio'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'factorRatio'  ? 'sort-desc' : '']"  
                      @click="sort('factorRatio')">FACTOR <br> RATIO</th> -->
                    <th 
                      v-if="isAdmin" 
                      scope="col" 
                      class="sort text-center"
                      v-bind:class="[sortOrder == 'ASC' && sortColumn == 'traderName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'traderName'  ? 'sort-desc' : '']"  
                      @click="sort('traderName')">TRADER </th>
                    <!-- <th scope="col" class=" text-center">UPDATE BY YIELD </th> -->
                    <th scope="col" class=" text-center">UPDATE BY PRICE </th>
                    <th scope="col" class=" text-center">ACTION</th>
                  </tr>
                </thead>
                <tbody class="list">
                   <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p>
                    </td>
                  </tr>
                  <tr v-for="bid in bids" :key="bid.id"  v-bind:class="{'active-row': bid.isActive , 'cancel-bid-row' : bid.status != 'NEW'}">
                      <td v-if="bid.status == 'NEW'" class="text-center"  >
                        <input @click="selectSingleBid()" v-model="bid.isSelect" type="checkbox" class="form-check-input" />
                      </td>
                      <td v-if="bid.status != 'NEW'"></td>
                      <td @click="getBidDetails(bid)">
                        <span class="cusips">{{bid.cusipVal}}</span>
                        <span class="coupon">{{bid.cusipCoupon |  percent(3) }}</span>
                        <!-- <span class="desc">{{bid.cusipDescription}}</span> -->
                      </td>
                      <td class="text-center">
                        <span class="maturity">{{moment(bid.cusipMaturityDate).format("MM/DD/YYYY")}}</span><br>
                        {{bid.cusipCallDate ? moment(bid.cusipCallDate).format("MM/DD/YYYY") : "N/A"}}
                      </td>
                      <td>
                        <span class="state">{{getStateName(bid.cusipStateId)}}</span>
                        <span class="insurer">{{bid.cusipBondInsurer ? bid.cusipBondInsurer : "N/A"}}</span>
                      </td>
                      <td>
                        <span class="text-primary">{{bid.amount | currency}}</span>
                        <!-- <input :disabled="bid.status != 'NEW'" v-if="bid.bidType != 'YIELD'"  v-on:click.stop.prevent="" class="form-control form-control-sm" type="number" placeholder="0" v-model="bid.amount"> -->
                      
                      <td class="text-center">{{bid.quantity}}</td>
                      <td class="text-center">{{bid.minQuantity}}</td>
                      <td class="text-center">
                        <span>{{bid.bidKeepCancel ? bid.bidKeepCancel : "N/A"}}</span>
                      </td>
                      <td v-on:click.stop.prevent="">
                        <select :disabled="bid.status != 'NEW'" class="form-control number" id="exampleFormControlSelect1"  v-model="bid.bidValidity">
                            <option
                              v-for="validity in bidValidity"
                              :key="validity"
                            >{{validity}}</option>
                        </select>                  
                      </td>
                      <!-- <td class="text-center">
                        <span v-if="bid.bidType == 'YIELD'" class="bid text-success">{{bid.pointToDate}} </span>
                        <span v-if="bid.bidType == 'YIELD'" class="bid text-primary">{{bid.pointToCurve}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'">{{bid.curveYield}}</span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>

                      </td>
                      <td 
                        class="text-center"><span v-if="bid.bidType == 'YIELD'">{{bid.yieldSpread}}</span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>

                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'"> MIN {{bid.minBps ? bid.minBps : 0}} / MAX {{bid.maxBps ?  bid.maxBps : 0}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td>
                      <td 
                        class="text-center">
                        <span v-if="bid.bidType == 'YIELD'"> 1 : {{bid.factorRatio || 0}} </span>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td> -->
                      <td 
                        v-if="isAdmin" 
                        class="text-center" 
                        @click="getTraderInfo(bid.cognitoSub)">{{bid.traderName}}
                      </td>
                      <!-- <td class="text-center customSel" v-on:click.stop.prevent="">
                        <div v-if="bid.bidType == 'YIELD'" class="input-group d-inline-flex">
                          <select :disabled="bid.status != 'NEW'" class="form-select h38" id="inputGroupSelect01" v-model="bid.yieldValueOperator">
                            <option value="+" selected>+</option>
                            <option value="-">-</option>
                          </select>   
                          <input :disabled="bid.status != 'NEW'" type="text" class="form-control" @keypress="isNumber($event)"  v-model="bid.yieldValue">
                          <div class="position-absolute">%</div>
                        </div>
                        <span v-if="bid.bidType == 'BIDPRICE'">N/A</span>
                      </td> -->
                      <td class="text-center customSel" v-on:click.stop.prevent="" >
                        <div  v-if="bid.bidType == 'BIDPRICE'" class="input-group d-inline-flex">
                          <select :disabled="bid.status != 'NEW'" class="form-select h38" id="inputGroupSelect01" v-model="bid.priceValueOperator">
                            <option value="+" selected>+</option>
                            <option value="-">-</option>
                          </select>   
                          <input :disabled="bid.status != 'NEW'" type="text" class="form-control" @keypress="isNumber($event)"  v-model="bid.priceValue">
                        </div>
                        <span v-if="bid.bidType == 'YIELD'">N/A</span>

                      </td>
                      <td class="text-center" > 
                        <button v-if="bid.status == 'NEW'" @click="selectedBid = bid" data-toggle="modal" data-target="#updateBid" type="button"  class="btn btn-primary btn-sm my-2"><i class="fas fa-check"></i> UPDATE</button>
                         <a 
                          data-toggle="tooltip" 
                          title="Cancel Bid"  
                          style="display:inline-block" 
                        >
                        <span v-if="bid.status == 'NEW'" @click="selectedBid = bid" class="btn-icon btn-danger" data-toggle="modal" data-target="#cancelBidByIdModal"   >
                            <i class="fas fa-times-circle"></i>
                        </span>
                        </a>
                        <span v-if="bid.status != 'NEW'" style="float:left">
                          <button @click="checkOutstandingBid(bid);" v-on:click.stop.prevent="" type="button"  class="btn btn-success btn-sm my-2">
                            <i class="fas fa-upload"></i> REUPLOAD</button>
                          </span>
                      </td>
                    </tr>
                </tbody>
              </table>
               <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getBidList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{totalRows}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer -->
      <!-- <Footer /> -->
      <!-- Cancel All Bids -->
      <div
        class="modal fade"
        id="cancelAllBidModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p>{{appMessages.cancelAllBidsConfirm}}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button v-if="isAdmin" type="button" class="btn btn-danger" @click="cancelAllBidsByAdmin()">Yes</button>
              <button v-if="isTrader && !isAdmin " type="button" class="btn btn-danger" @click="cancelAllBidsByTrader()">Yes</button>
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div>
      <!-- Cancel Bid by id -->
      <div
        class="modal fade"
        id="cancelBidByIdModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p>{{appMessages.cancelBidConfirm}}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="cancelBidById(selectedBid.id)">Yes</button>
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div> 
      <!-- Update All Bid Yield -->
      <div
        class="modal fade"
        id="updateAllYield"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p v-if="bidsSelectedUpdate.length == 0" >{{appMessages.updateAllYields}}</p>
              <p v-if="bidsSelectedUpdate.length != 0" >Are you sure you want to update selected bids yield?</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button  type="button" class="btn btn-danger" @click="updateAllYield()">Yes</button>
              <!-- <button v-if="isTrader && !isAdmin" type="button" class="btn btn-danger" @click="updateAllYieldByTrader()">Yes</button> -->
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div>
      <!-- Update All Bid Price -->
        <div
        class="modal fade"
        id="updateAllPrice"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p v-if="bidsSelectedUpdate.length == 0">{{appMessages.updateAllbidPrice}}</p>
              <p v-if="bidsSelectedUpdate.length != 0" >Are you sure you want to update selected bids price?</p>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button  type="button" class="btn btn-danger" @click="updateAllBidPrice()">Yes</button>
              <!-- <button v-if="isTrader && !isAdmin" type="button" class="btn btn-danger" @click="updateAllBidPriceByTrader()">Yes</button> -->
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div>
      <!-- Update Bid -->
       <div
        class="modal fade"
        id="updateBid"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p>{{appMessages.bidUpdate}}</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="updateBid()">Yes</button>
              <div v-if="loading" class="loader"><img src="../../../assets/img/loader.svg" alt=""/></div>

            </div>
          </div>
        </div>
      </div>
      <trader-info v-bind:traderInfo="traderData" v-if="modalOpen" @close="modalOpen = false"></trader-info>
      <cancel-bid-info 
        v-bind:bid="bidSelected"
        @close="bidSelected = null"
        v-if="bidSelected"
      ></cancel-bid-info>
      <out-standing-bid-exist
        v-bind:outStandingBid="outStandingBid"
        v-bind:selectedCusip="selectedBid"
        @close="outStandingBid = null"
        @create="cancelBidAndPlaceNewBid()"
        v-if="outStandingBid"
        >
      </out-standing-bid-exist>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import TraderInfo from "./TraderInfoPopup"
import stateConstants from "@/stateConstants";
import CancelBidInfo from "./CancelBidInfo";
import OutStandingBidExist from "../trader/bid/OutstandingBidExistPopup"
import Datepicker from 'vuejs-datepicker';

export default {
  name: "outstandingbid",
   components: {
    // Header,
    // Footer,
    TraderInfo,
    CancelBidInfo,
    OutStandingBidExist,
    Datepicker
  },
  data() {
    return {
      accessToken: null,
      bids:[],
      //bids: [{"isActive":false,"id":1106,"cusipVal":"10608MHW9","maturityDate":"2039-09-01T00:00:00.000+0000","bondInsurer":"BUILD AMERICA MUTUAL","traderName":"Arun Reghu","state":"Texas","purpose":"Gen purp/ pub impt","description":"BRAZORIA CNTY TEX MUN UTIL DIST NO 55 02.37500% 09/01/2039 UNLTD TAX BDS SER. 2020","status":"ACTIVE"}],
      bidstoCancel : [],
      selectedBid : {},
      config: config,
      loading : false,
      currentPage: 1,
      perPage: 10,
      searchValue : "",
      totalRows : 1,
      isSelectAll : false,
      sortColumn: "latestDate",
      sortOrder: "DESC",
      traderData:{},
      modalOpen: false,
      isAdmin: false,
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      cognitoSub : null,
      allYieldValue : "",
      allBidValue : "",
      allYieldValueOperator : "+",
      allBidValueOperator : "+",
      yieldValue : "",
      yieldValueOperator : "+",
      bidValidity : 3,
      stateConstants: stateConstants,
      bidSelected : null,
      outStandingBid : null,
      showFilters : false,
      traderList : [],
      filterTrader : null,
      fromDateExport : "",
      toDateExport : "",
      selectedBidValidity : "1",
      bidsSelectedUpdate : [],
      bidValues : {}
    };
  },
  methods: {
    openPriceUpdateConfirm(){
      let bisIdsForUpdateYield = [];
      this.bidsSelectedUpdate.forEach(checkedId => {
        this.bids.forEach(function(bid) {
          if(bid.id === checkedId && bid.bidType == "BIDPRICE"){
            bisIdsForUpdateYield.push(bid.id)
          }
        });
      });
      if(this.bidsSelectedUpdate.length > 0 && bisIdsForUpdateYield.length == 0){
        this.$alert("Please select at least one bid with type price.","","warning");
        return false;
      }
      window.$("#updateAllPrice").modal("show");
    },
    openYieldUpdateConfirm(){
      let bisIdsForUpdateYield = [];
      this.bidsSelectedUpdate.forEach(checkedId => {
        this.bids.forEach(function(bid) {
          if(bid.id === checkedId && bid.bidType == "YIELD"){
            bisIdsForUpdateYield.push(bid.id)
          }
        });
      });
      if(this.bidsSelectedUpdate.length > 0 && bisIdsForUpdateYield.length == 0){
        this.$alert("Please select at least one bid with type yield.","","warning");
        return false;
      }
      window.$("#updateAllYield").modal("show");
    },
    selectSingleBid(){
      var self =  this;
      this.bidsSelectedUpdate = [];
      setTimeout(() => {
        this.bids.forEach(function(bid) {
          if(bid.isSelect){
            self.bidsSelectedUpdate.push(bid.id);
          }
        });
      },100)
    },
    selectAll(){
      var self =  this;
      this.bidsSelectedUpdate = [];
       this.bids.forEach(function(bid) {
         if(bid.status == 'NEW'){
            bid.isSelect = self.isSelectAll;
            if(self.isSelectAll){
              self.bidsSelectedUpdate.push(bid.id);
            }
         }
        
      });
    },
    resetToDefaut(){
      this.bidsSelectedUpdate = []; 
      this.isSelectAll = false;
      this.bids.forEach(function(bid) {
        bid.isSelect = false;
      });

    },
    updateAllBidValidity(){
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
       var message = this.bidsSelectedUpdate.length == 0 ? "Are you sure you want to update all bids validity?" : "Are you sure you want to update selected bids validity?" ;
      if(this.isTrader && !this.isAdmin){//If logged user is trader only
        this.filterTrader = {'id' :authService.getUser().id};
      }   
      this.$confirm(message).then(() => {
        this.loading = true;
        this.$http
          .put(
            config.baseUrlBidSide + "/bid/update-bid-validity",
            {
              bidIds: this.bidsSelectedUpdate,
              bidValidity : Number(this.selectedBidValidity),
              userId : this.filterTrader ? this.filterTrader.id : "",
              cognitoSub : this.cognitoSub
            },
            auth
          )
          .then(() => {
            this.$alert("Bid validity update in progress.","","success");
            this.getBidList(); 
            this.loading = false;
            this.resetToDefaut();

          })
          .catch(e => {
            console.log(e);
            this.loading = false;
          });
      })
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getTraderInfo(cognitoSub){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            cognitoSub,
            auth
        )
        .then(result => {
          this.modalOpen = true;
          this.traderData = result.data;
          this.loading = false;

        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });
    },
    searchBid(){
      this.getBidList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getBidList(); 
    },
    selectAllBids(event){
      this.bids.forEach(function(bid) {
        bid.isCancel = event.target.checked;
      });
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getBidList();
    },
    cancelAllBidsByAdmin(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/bid/cancel-all",
          {
            cognitoSub : this.cognitoSub
          },
          auth
        )
        .then(response => {
          console.log(response);
          window.$("#cancelAllBidModal").modal("hide");
          this.$alert("Bid cancellation in progress.","","success");
          this.getBidList(); 
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    cancelAllBidsByTrader(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/bid/cancel",
          {
            bidIds: [],
            traderIds : [],
            cognitoSub : this.cognitoSub
          },
          auth
        )
        .then(response => {
          console.log(response);
          window.$("#cancelAllBidModal").modal("hide");
          this.$alert("Bid cancellation in progress.","","success");
          this.getBidList(); 
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    cancelBidById(bidId){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/bid/cancel",
          {
            bidIds: [bidId],
            cognitoSub : this.cognitoSub
          },
          auth
        )
        .then(response => {
          console.log(response);
          window.$("#cancelBidByIdModal").modal("hide");
          this.getBidList(this.currentPage); 
          this.loading = false;
          this.resetToDefaut();
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    getBidList(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken()  }
      };
      var subId = (!this.isAdmin && this.isTrader) ? this.cognitoSub : "";
      var userId = this.filterTrader ? this.filterTrader.id : "";
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/list?page=" +
            currentPage+
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=NEW,CANCEL_TRADER,CANCEL_ADMIN,CANCEL_CURVE,CANCEL_MIN_QUANTITY,CANCEL_DAILIY,CANCEL_YIELD_UPDATE,CANCEL_PENDING"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
             subId+
             "&userId="+
             userId,
            auth

        )
        .then(result => {
          console.log(result);
          //this.loading = false;
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(bid) {
            bid.isCancel = false;
            bid.isActive = false;
            bid.yieldValueOperator = '+';
            bid.priceValueOperator = '+';
            if(bid.pointToCurve == 'MUNICURVE') bid.pointToCurve  = 'Muni Curve';
            if(bid.pointToCurve == 'TENYEARTREASURRY') bid.pointToCurve  = '10 Year Treasury';
          });
          this.bids = result.data.content;  
          this.getBidParValue();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getBidParValue(currentPage) {
      this.loading = true;
      if (!currentPage) {
        currentPage = 1;
      }
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken()  }
      };
      var subId = (!this.isAdmin && this.isTrader) ? this.cognitoSub : "";
      var userId = this.filterTrader ? this.filterTrader.id : "";
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/list-par?page=" +
            currentPage+
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status=NEW"+
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cognitoSub="+
             subId+
             "&userId="+
             userId,
            auth

        )
        .then(result => {
          this.bidValues = result.data;
          this.loading = false
        })
        .catch(() => {
          
        });
    },
    getBidDetails(bidSelected){
      this.bids.forEach(function(bid) {
        bid.isActive = false;
      });
      bidSelected.isActive = true;
      this.bidSelected = bidSelected;
    },
    updateAllYield(){
      const auth = {
              headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
            };
      if(this.isTrader && !this.isAdmin){//If logged user is trader only
        this.filterTrader = {'id' : authService.getUser().id};
      }
      let bisIdsForUpdateYield = [];
      this.bidsSelectedUpdate.forEach(checkedId => {
        this.bids.forEach(function(bid) {
          if(bid.id === checkedId && bid.bidType == "YIELD"){
            bisIdsForUpdateYield.push(bid.id)
          }
        });
      });
      if(this.bidsSelectedUpdate.length > 0 && bisIdsForUpdateYield.length == 0){
        this.$alert("error");
        return false;
      }
      this.loading = true;   
      this.$http
        .put(
          config.baseUrlBidSide + "/bid/update-all-yield",
          {
            percent: this.allYieldValueOperator == '+' ? this.allYieldValue : (this.allYieldValueOperator + this.allYieldValue),
            bidType : "YIELD",
            userId : this.filterTrader ? this.filterTrader.id : "",
            bidIds : bisIdsForUpdateYield,
            cognitoSub : this.cognitoSub
          },
          auth
        )
        .then(response => {
          console.log(response);
          window.$("#updateAllYield").modal("hide");
          this.$alert("Yield update in progress.","","success");
          this.allYieldValue = "";
          this.getBidList(); 
          this.loading = false;
          this.resetToDefaut();


        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    updateAllBidPrice(){
      this.loading = true;
      const auth = {
              headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
            };
      if(this.isTrader && !this.isAdmin){//If logged user is trader only
        this.filterTrader = {'id' :authService.getUser().id};
      } 
      let bisIdsForUpdateYield = [];
      this.bidsSelectedUpdate.forEach(checkedId => {
        this.bids.forEach(function(bid) {
          if(bid.id === checkedId && bid.bidType == "BIDPRICE"){
            bisIdsForUpdateYield.push(bid.id)
          }
        });
      });        
      this.$http
        .put(
          config.baseUrlBidSide + "/bid/update-all-yield",
          {
            percent: this.allBidValueOperator == '+' ? this.allBidValue : (this.allBidValueOperator + this.allBidValue),
            bidType : "BIDPRICE",
            userId : this.filterTrader ? this.filterTrader.id : "",
            bidIds : bisIdsForUpdateYield,
            cognitoSub : this.cognitoSub

          },
          auth
        )
        .then(() => {
          window.$("#updateAllPrice").modal("hide");
          this.$alert("price update in progress.","","success");
          this.allBidValue = "";
          this.getBidList(); 
          this.loading = false;
          this.resetToDefaut();

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    updateBid(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      var YieldOrBidPrice = "";
      if(this.selectedBid.bidType == 'YIELD'){
        YieldOrBidPrice = this.selectedBid.yieldValueOperator == '+' ? this.selectedBid.yieldValue : (this.selectedBid.yieldValueOperator + this.selectedBid.yieldValue)
      }
       if(this.selectedBid.bidType == 'BIDPRICE'){
         YieldOrBidPrice = this.selectedBid.priceValueOperator == '+' ? this.selectedBid.priceValue : (this.selectedBid.priceValueOperator + this.selectedBid.priceValue)
       }
      this.$http
        .put(
          config.baseUrlBidSide + "/bid",
          { 
            bidId : this.selectedBid.id,
            percent: YieldOrBidPrice,
            bidValidity : this.selectedBid.bidValidity,
            cognitoSub : this.cognitoSub
            // tmcPrice : this.selectedBid.bidType == 'YIELD' ? Number(this.selectedBid.tmcPrice) : null

          },
          auth
        )
        .then(response => {
          console.log(response);
          window.$("#updateBid").modal("hide");
          this.yieldValue = "";
          this.getBidList(this.currentPage); 
          this.loading = false;

        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    reUpload(){
        var message = "Are you sure you want to reupload this bid?";

        this.$confirm(message).then(() => {
           this.createBid();
        });
    },
    createBid(){
        var pointToCurveOnReupload = null;
        if(this.selectedBid.pointToCurve == 'Muni Curve') pointToCurveOnReupload  = 'MUNICURVE';
        if(this.selectedBid.pointToCurve == '10 Year Treasury') pointToCurveOnReupload  = 'TENYEARTREASURRY';
        var dataTosend =  {
            cusipId : this.selectedBid.cusipId,
            traderCognitoSub : this.cognitoSub,
            quantity : Number(this.selectedBid.quantity),
            amount : Number(this.selectedBid.amount),
            bidValidity : Number(this.selectedBid.bidValidity),
            bidType   : this.selectedBid.bidType,
            minQuantity   : this.selectedBid.minQuantity,
            pointToDate : this.selectedBid.pointToDate,
            pointToCurve : pointToCurveOnReupload,
            factorRatio  : this.selectedBid.factorRatio,
            curveYield : this.selectedBid.curveYield,
            yieldSpread : this.selectedBid.yieldSpread ,
            minBps : this.selectedBid.minBps ,
            maxBps : this.selectedBid.maxBps,
            tmcPrice : this.selectedBid.tmcPrice ,
            bidKeepCancel : this.selectedBid.bidKeepCancel

          }
      this.loader = true;
      const auth = {
          headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
              config.baseUrlBidSide + "/bid",
                dataTosend,
            auth
        )
        .then(() => {
          this.outStandingBid = null;
          this.selectedBid = null;
          this.getBidList(this.currentPage); 
            
        })
        .catch(() => {
            
        });

    },
    checkOutstandingBid(bid){
      this.loading = true;
      this.selectedBid = bid;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/bid/outstanding/list?cusipId="+
            this.selectedBid.cusipId,
          auth
        )
        .then(response => {
          this.outStandingBid = response.data;
          this.loading = false;
          if(!this.outStandingBid) this.reUpload();
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
    cancelBidAndPlaceNewBid(){
      this.createBid();
    },
    getBidSettings(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
          "/user?cognitoSub="+
            this.cognitoSub,
          auth
        )
        .then(response => {
          this.bidValidity = response.data.bidValidity || 3;
          
        })
        .catch(e => {
          console.log(e);
        });
    },
    isNumber: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getTraderList(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=100&search=&status=&sortColumn=firstName&sortOrder=ASC&group="+this.tenantName+"-Trader",
            auth
        )
        .then(result => {
          // this.traderList = result.data.content.filter((e) => {return e.traderId != null});
          result.data.content.forEach(trader =>{
            trader.firstName =  trader.firstName+" "+trader.lastName;
          });
          this.traderList = result.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    clearFilter(){
      this.filterTrader = null;
      this.getBidList(); 
    },
    exportToExcel(){
      this.loading = true;
      var fDate = this.moment(this.fromDateExport).format("YYYY-MM-DD");
      var tDate = this.moment(this.toDateExport).format("YYYY-MM-DD");
      var cognitoSub = this.filterTrader ? this.filterTrader.cognitoSub : "";
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/excel/report-bids?fromDate="+fDate+"&toDate="+tDate+"&cognitoSub="+cognitoSub,
            auth
        )
        .then((response) => {
          window.open(response.data, "_blank");
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          //Error Occured so forcefully logged out 
          this.loading = false;

        });

    }   
    
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.$cognitoAuth.getUserGroup((err, role) => {
          if (err) {
            console.log("accessToken is not found", err);
          } else {
            this.tenantName = role[0].split("-")[0];
            var roleArray = role.map(item => {
              return  item.split("-")[1];
            })
            roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
            roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
            roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
            roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
            this.cognitoSub = authService.getUser().cognitoSub;
            this.fromDateExport = this.moment().format("MM-DD-YYYY");
            this.toDateExport = this.moment().add(1,'days').format("MM-DD-YYYY");
            this.getBidList();
            this.getBidSettings();
            this.getTraderList();
            // this.getBidParValue();
          }
        });
        
        
      }
    });
    this.$root.$on("bidupdated", () => {
      this.getBidList();
    });

  },
  beforeDestroy() {
    this.$root.$off("bidupdated");
  }
   
  
};
</script>